import React, { useEffect } from 'react';

const AuthCallback = () => {
  useEffect(() => {
    // Get session_id from URL hash
    const hash = window.location.hash;
    
    if (hash && hash.includes('session_id=')) {
      const sessionId = hash.split('session_id=')[1].split('&')[0];
      
      // Send session_id to parent window (opener)
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'oauth_success',
            session_id: sessionId
          },
          window.location.origin
        );
        
        // Close the popup
        window.close();
      } else {
        // Fallback: if not a popup, redirect to auth page with session
        window.location.href = `/auth#session_id=${sessionId}`;
      }
    } else {
      // No session_id found
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'oauth_error',
            error: 'No session ID received'
          },
          window.location.origin
        );
        window.close();
      } else {
        window.location.href = '/auth';
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-orange-400 mx-auto mb-4"></div>
        <p className="text-gray-400">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
